
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  
  Flits(document).on('Flits:SocialLogin:Loaded', function(event){  
    setTimeout(function(){
      if (location.pathname.indexOf("/account") == -1){  
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }, 800);
  });

  Flits(window).load(function() {  
    if (location.pathname.indexOf("/account") == -1){     
      if (location.pathname.indexOf("checkout") != -1)
      {
        Flits.setLocalStorage('flits_before_login_url',location.pathname);
      }else{
        Flits.setLocalStorage('flits_before_login_url','/account');
      }
    }
  });
  
  
}(Flits));
